import { render, staticRenderFns } from "./newsFrom copy.vue?vue&type=template&id=983b852a"
import script from "./newsFrom copy.vue?vue&type=script&lang=js"
export * from "./newsFrom copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('983b852a')) {
      api.createRecord('983b852a', component.options)
    } else {
      api.reload('983b852a', component.options)
    }
    module.hot.accept("./newsFrom copy.vue?vue&type=template&id=983b852a", function () {
      api.rerender('983b852a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/message/templateManage/templateFrom/newsFrom copy.vue"
export default component.exports